export default [
  {
    path: '/',
    redirect: 'login',
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/pages/Login.vue'),
    meta: {
      layout: 'blank',
      title: 'login',
      skipAuth: true,
    },
  },
  {
    path: `/{{studentPrefix}}-login/:username?`,
    name: 'StudentLogin',
    component: () => import('@/views/pages/StudentLogin.vue'),
    meta: {
      layout: 'blank',
      title: 'login',
      skipAuth: true,
      isStudent: true,
      prefix: '{{studentPrefix}}',
    },
  },
  {
    path: `/{{studentPrefix}}-info/:username?`,
    name: 'StudentUserDetails',
    component: () => import('@/views/pages/user/Student/StudentDetails.vue'),
    meta: {
      ref: ['student-user'],
      layout: 'content',
      title: 'menu.studentInfo',
      requireAuth: true,
      cannotAccess: ['StudentUserDetails'],
      isStudent: true,
      prefix: '{{studentPrefix}}',
    },
  },
  {
    path: `/{{studentPrefix}}-attendance/:username`,
    name: 'StudentUserAttendance',
    component: () => import('@/views/pages/user/Student/StudentAttendance.vue'),
    meta: {
      ref: ['student-user-attendance'],
      layout: 'content',
      title: 'attendanceRecord',
      requireAuth: true,
      cannotAccess: ['StudentUserAttendance'],
      isStudent: true,
      prefix: '{{studentPrefix}}',
    },
  },
  {
    path: `/{{studentPrefix}}-order/:username`,
    name: 'StudentUserOrderList',
    component: () => import('@/views/pages/user/Order/OrderList.vue'),
    meta: {
      ref: ['student-user-order'],
      layout: 'content',
      title: 'menu.order',
      requireAuth: true,
      cannotAccess: ['StudentUserOrderList'],
      isStudent: true,
      prefix: '{{studentPrefix}}',
    },
  },
  {
    path: `/{{studentPrefix}}-requirement/:username`,
    name: 'StudentSwitchRequirement',
    component: () => import('@/views/pages/user/SwitchRequirement.vue'),
    meta: {
      ref: ['student-requirement'],
      layout: 'content',
      title: 'menu.requirement',
      requireAuth: true,
      cannotAccess: ['StudentSwitchRequirement'],
      isStudent: true,
      prefix: '{{studentPrefix}}',
    },
  },
  {
    path: `/{{studentPrefix}}-points/:username`,
    name: 'StudentUserPoints',
    component: () => import('@/views/pages/user/Student/StudentPoints.vue'),
    meta: {
      layout: 'content',
      title: 'menu.pointsRecord',
      requireAuth: true,
      cannotAccess: ['StudentUserPoints'],
      isStudent: true,
      prefix: '{{studentPrefix}}',
    },
  },
  {
    path: '/blogs/:username',
    name: 'StudentBlogList',
    component: () => import('@/views/pages/user/Blog/BlogList.vue'),
    meta: {
      ref: ['student-blog'],
      layout: 'content',
      title: 'menu.blog',
      requireAuth: true,
      cannotAccess: ['StudentBlogList'],
      isStudent: true,
      prefix: '{{studentPrefix}}',
    },
  },
  {
    path: '/blogs/:username/details/:id',
    name: 'StudentBlogDetails',
    component: () => import('@/views/pages/student/BlogDetails.vue'),
    meta: {
      ref: ['student-blog'],
      layout: 'content',
      title: 'blogDetails',
      requireAuth: true,
      cannotAccess: ['StudentBlogDetails'],
      isStudent: true,
      prefix: '{{studentPrefix}}',
    },
  },
  {
    path: '/pay-tuition',
    name: 'PayTuitionList',
    component: () => import('@/views/pages/user/PayTuition/PayTuitionList.vue'),
    meta: {
      ref: ['pay-tuition'],
      layout: 'content',
      title: 'menu.payTuition',
      requireAuth: true,
      cannotAccess: ['PayTuitionList'],
    },
  },
  {
    path: '/pay-tuition-status',
    name: 'PayTuitionListWithStatus',
    component: () => import('@/views/pages/user/PayTuition/PayTuitionList.vue'),
    meta: {
      ref: ['pay-tuition'],
      layout: 'content',
      title: 'menu.payTuition',
      requireAuth: true,
      cannotAccess: ['PayTuitionList'],
    },
  },
  {
    path: '/pay-tuition/payment/:id',
    name: 'PayTuitionPayment',
    component: () => import('@/views/pages/user/PayTuition/PayTuitionPayment.vue'),
    meta: {
      ref: ['pay-tuition'],
      layout: 'content',
      title: 'menu.payTuition',
      requireAuth: true,
      cannotAccess: ['PayTuitionPayment'],
    },
  },
  {
    path: '/timetable',
    name: 'Timetable',
    component: () => import('@/views/pages/user/CourseTimetable/Timetable.vue'),
    meta: {
      ref: ['timetable'],
      layout: 'content',
      title: 'menu.timetable',
      requireAuth: true,
      cannotAccess: ['Timetable'],
    },
  },
  {
    path: '/timetable/class/create',
    name: 'CreateClass',
    component: () => import('@/views/pages/user/CourseTimetable/CreateClass.vue'),
    meta: {
      ref: ['timetable'],
      layout: 'content',
      title: 'createTimetable',
      requireAuth: true,
      cannotAccess: ['CreateClass'],
    },
  },
  {
    path: '/timetable/lesson/:id',
    name: 'ClassDetails',
    component: () => import('@/views/pages/user/CourseTimetable/ClassDetails.vue'),
    meta: {
      ref: ['timetable'],
      layout: 'content',
      title: 'menu.timetable',
      requireAuth: true,
      cannotAccess: ['ClassDetails'],
    },
  },
  {
    path: `/{{studentPrefix}}`,
    name: 'StudentList',
    component: () => import('@/views/pages/user/Student/StudentList.vue'),
    meta: {
      ref: ['student'],
      layout: 'content',
      title: 'menu.student',
      requireAuth: true,
      cannotAccess: ['StudentList'],
    },
  },
  {
    path: `/{{studentPrefix}}/details/:id`,
    name: 'StudentDetails',
    component: () => import('@/views/pages/user/Student/StudentDetails.vue'),
    meta: {
      ref: ['student'],
      layout: 'content',
      title: 'studentDetails',
      requireAuth: true,
      cannotAccess: ['StudentDetails'],
    },
  },
  {
    path: `/{{studentPrefix}}/create`,
    name: 'CreateStudent',
    component: () => import('@/views/pages/user/Student/StudentDetails.vue'),
    meta: {
      ref: ['student'],
      layout: 'content',
      title: 'createStudent',
      requireAuth: true,
      cannotAccess: ['CreateStudent'],
    },
  },
  {
    path: `/{{studentPrefix}}/attendance/:id`,
    name: 'StudentAttendance',
    component: () => import('@/views/pages/user/Student/StudentAttendance.vue'),
    meta: {
      ref: ['student'],
      layout: 'content',
      title: 'attendanceRecord',
      requireAuth: true,
      cannotAccess: ['StudentAttendance'],
    },
  },
  {
    path: `/{{studentPrefix}}/points/:id`,
    name: 'StudentPoints',
    component: () => import('@/views/pages/user/Student/StudentPoints.vue'),
    meta: {
      layout: 'content',
      title: 'menu.pointsRecord',
      requireAuth: true,
      cannotAccess: ['StudentPoints'],
    },
  },
  {
    path: `/{{studentPrefix}}/action-log/:id`,
    name: 'ActionLog',
    component: () => import('@/views/pages/user/Student/ActionLog.vue'),
    meta: {
      ref: ['student'],
      layout: 'content',
      title: 'menu.actionLog',
      requireAuth: true,
      cannotAccess: ['ActionLog'],
    },
  },
  {
    path: '/course',
    name: 'CourseList',
    component: () => import('@/views/pages/user/Course/CourseList.vue'),
    meta: {
      ref: ['course', 'course-list'],
      layout: 'content',
      title: 'menu.allCourses',
      requireAuth: true,
      cannotAccess: ['CourseList'],
    },
  },
  {
    path: '/course/details/:id',
    name: 'CourseDetails',
    component: () => import('@/views/pages/user/Course/CourseDetails.vue'),
    meta: {
      ref: ['course', 'course-list'],
      layout: 'content',
      title: 'courseDetails',
      requireAuth: true,
      cannotAccess: ['CourseDetails'],
    },
  },
  {
    path: '/course/create',
    name: 'CreateCourse',
    component: () => import('@/views/pages/user/Course/CourseDetails.vue'),
    meta: {
      ref: ['course', 'course-list'],
      layout: 'content',
      title: 'createCourse',
      requireAuth: true,
      cannotAccess: ['CreateCourse'],
    },
  },
  {
    path: '/course-category',
    name: 'CourseCategoryList',
    component: () => import('@/views/pages/user/Course/CourseCategoryList.vue'),
    meta: {
      ref: ['course', 'course-category'],
      layout: 'content',
      title: 'menu.courseCategory',
      requireAuth: true,
      cannotAccess: ['CourseCategoryList'],
    },
  },
  {
    path: '/course-category/create',
    name: 'CreateCourseCategory',
    component: () => import('@/views/pages/user/Course/CourseCategoryDetails.vue'),
    meta: {
      ref: ['course', 'course-category'],
      layout: 'content',
      title: 'createCategory',
      requireAuth: true,
      cannotAccess: ['CreateCourseCategory'],
    },
  },
  {
    path: '/course-category/details/:id',
    name: 'CourseCategoryDetails',
    component: () => import('@/views/pages/user/Course/CourseCategoryDetails.vue'),
    meta: {
      ref: ['course', 'course-category'],
      layout: 'content',
      title: 'courseCategoryDetails',
      requireAuth: true,
      cannotAccess: ['CourseCategoryDetails'],
    },
  },
  {
    path: '/online-course',
    name: 'OnlineCourseList',
    component: () => import('@/views/pages/user/Course/OnlineCourseList.vue'),
    meta: {
      ref: ['online-course', 'online-course-list'],
      layout: 'content',
      title: 'menu.allOnlineCourse',
      requireAuth: true,
      cannotAccess: ['CourseList'],
    },
  },
  {
    path: '/online-course/create',
    name: 'CreateOnlineCourse',
    component: () => import('@/views/pages/user/Course/OnlineCourseDetails.vue'),
    meta: {
      ref: ['online-course', 'online-course-list'],
      layout: 'content',
      title: 'createCourse',
      requireAuth: true,
      cannotAccess: ['CreateCourse'],
    },
  },
  {
    path: '/online-course/details/:id',
    name: 'OnlineCourseDetails',
    component: () => import('@/views/pages/user/Course/OnlineCourseDetails.vue'),
    meta: {
      ref: ['online-course', 'online-course-list'],
      layout: 'content',
      title: 'onlineCourseDetails',
      requireAuth: true,
      cannotAccess: ['CourseDetails'],
    },
  },
  {
    path: '/online-course-category',
    name: 'OnlineCourseCategoryList',
    component: () => import('@/views/pages/user/Course/OnlineCourseCategoryList.vue'),
    meta: {
      ref: ['online-course', 'online-course-category'],
      layout: 'content',
      title: 'menu.onlineCourseCategory',
      requireAuth: true,
      cannotAccess: ['CourseCategoryList'],
    },
  },
  {
    path: '/online-course-category/create',
    name: 'CreateOnlineCourseCategory',
    component: () => import('@/views/pages/user/Course/OnlineCourseCategoryDetails.vue'),
    meta: {
      ref: ['online-course', 'online-course-category'],
      layout: 'content',
      title: 'createCategory',
      requireAuth: true,
      cannotAccess: ['CreateCourseCategory'],
    },
  },
  {
    path: '/online-course-category/details/:id',
    name: 'OnlineCourseCategoryDetails',
    component: () => import('@/views/pages/user/Course/OnlineCourseCategoryDetails.vue'),
    meta: {
      ref: ['online-course', 'online-course-category'],
      layout: 'content',
      title: 'onlineCourseCategoryDetails',
      requireAuth: true,
      cannotAccess: ['CourseCategoryDetails'],
    },
  },
  {
    path: '/order/:sid?',
    name: 'OrderList',
    component: () => import('@/views/pages/user/Order/OrderList.vue'),
    meta: {
      ref: ['order'],
      layout: 'content',
      title: 'recentInvoice',
      requireAuth: true,
      cannotAccess: ['OrderList'],
    },
  },
  {
    path: '/order/online/:cid',
    name: 'OnlineCourseOrderList',
    component: () => import('@/views/pages/user/Order/OrderList.vue'),
    meta: {
      ref: ['online-course', 'order'],
      layout: 'content',
      title: 'recentInvoice',
      requireAuth: true,
      cannotAccess: ['OrderList'],
    },
  },
  {
    path: '/product',
    name: 'ProductList',
    component: () => import('@/views/pages/user/Product/ProductList.vue'),
    meta: {
      ref: ['product', 'product-list'],
      layout: 'content',
      title: 'menu.product',
      requireAuth: true,
      cannotAccess: ['ProductList'],
    },
  },
  {
    path: '/product/details/:id',
    name: 'ProductDetails',
    component: () => import('@/views/pages/user/Product/ProductDetails.vue'),
    meta: {
      ref: ['product', 'product-list'],
      layout: 'content',
      title: 'productDetails',
      requireAuth: true,
      cannotAccess: ['ProductDetails'],
    },
  },
  {
    path: '/product/create',
    name: 'CreateProduct',
    component: () => import('@/views/pages/user/Product/ProductDetails.vue'),
    meta: {
      ref: ['product', 'product-list'],
      layout: 'content',
      title: 'createProduct',
      requireAuth: true,
      cannotAccess: ['CreateProduct'],
    },
  },
  {
    path: '/product-category',
    name: 'ProductCategoryList',
    component: () => import('@/views/pages/user/Product/ProductCategoryList.vue'),
    meta: {
      ref: ['product', 'product-category'],
      layout: 'content',
      title: 'menu.productCategory',
      requireAuth: true,
      cannotAccess: ['ProductCategoryList'],
    },
  },
  {
    path: '/product-category/details/:id',
    name: 'ProductCategoryDetails',
    component: () => import('@/views/pages/user/Product/ProductCategoryDetails.vue'),
    meta: {
      ref: ['product', 'product-category'],
      layout: 'content',
      title: 'productCategoryDetails',
      requireAuth: true,
      cannotAccess: ['ProductCategoryDetails'],
    },
  },
  {
    path: '/product-category/create',
    name: 'CreateProductCategory',
    component: () => import('@/views/pages/user/Product/ProductCategoryDetails.vue'),
    meta: {
      ref: ['product', 'product-category'],
      layout: 'content',
      title: 'createCategory',
      requireAuth: true,
      cannotAccess: ['CreateProductCategory'],
    },
  },
  {
    path: '/classroom',
    name: 'ClassroomList',
    component: () => import('@/views/pages/user/Classroom/ClassroomList.vue'),
    meta: {
      ref: ['classroom'],
      layout: 'content',
      title: 'menu.classroom',
      requireAuth: true,
      cannotAccess: ['ClassroomList'],
    },
  },
  {
    path: '/classroom/details/:id',
    name: 'ClassroomDetails',
    component: () => import('@/views/pages/user/Classroom/ClassroomDetails.vue'),
    meta: {
      ref: ['classroom'],
      layout: 'content',
      title: 'classroomDetails',
      requireAuth: true,
      cannotAccess: ['ClassroomDetails'],
    },
  },
  {
    path: '/classroom/create',
    name: 'CreateClassroom',
    component: () => import('@/views/pages/user/Classroom/ClassroomDetails.vue'),
    meta: {
      ref: ['classroom'],
      layout: 'content',
      title: 'createClassroom',
      requireAuth: true,
      cannotAccess: ['CreateClassroom'],
    },
  },
  {
    path: '/school',
    name: 'SchoolList',
    component: () => import('@/views/pages/user/School/SchoolList.vue'),
    meta: {
      ref: ['school'],
      layout: 'content',
      title: 'menu.campus',
      requireAuth: true,
      cannotAccess: ['SchoolList'],
    },
  },
  {
    path: '/school/details/:id',
    name: 'SchoolDetails',
    component: () => import('@/views/pages/user/School/SchoolDetails.vue'),
    meta: {
      ref: ['school'],
      layout: 'content',
      title: 'campusDetails',
      requireAuth: true,
      cannotAccess: ['SchoolDetails'],
    },
  },
  {
    path: '/school/create',
    name: 'CreateSchool',
    component: () => import('@/views/pages/user/School/SchoolDetails.vue'),
    meta: {
      ref: ['school'],
      layout: 'content',
      title: 'createCampus',
      requireAuth: true,
      cannotAccess: ['CreateSchool'],
    },
  },
  {
    path: '/tutor',
    name: 'TutorList',
    component: () => import('@/views/pages/user/Tutor/TutorList.vue'),
    meta: {
      ref: ['tutor', 'tutor-list'],
      layout: 'content',
      title: 'menu.tutor',
      requireAuth: true,
      cannotAccess: ['TutorList'],
    },
  },
  {
    path: '/tutor/details/:id',
    name: 'TutorDetails',
    component: () => import('@/views/pages/user/Tutor/TutorDetails.vue'),
    meta: {
      ref: ['tutor', 'tutor-list'],
      layout: 'content',
      title: 'tutorDetails',
      requireAuth: true,
      cannotAccess: ['TutorDetails'],
    },
  },
  {
    path: '/tutor/create',
    name: 'CreateTutor',
    component: () => import('@/views/pages/user/Tutor/TutorDetails.vue'),
    meta: {
      ref: ['tutor', 'tutor-list'],
      layout: 'content',
      title: 'createTutor',
      requireAuth: true,
      cannotAccess: ['CreateTutor'],
    },
  },
  {
    path: '/salary',
    name: 'SalaryReport',
    component: () => import('@/views/pages/user/Tutor/SalaryReport.vue'),
    meta: {
      ref: ['tutor', 'tutor-salary'],
      layout: 'content',
      title: 'menu.salaryReport',
      requireAuth: true,
      cannotAccess: ['SalaryReport', 'viewSalary'],
    },
  },
  {
    path: '/tutor-calendar',
    name: 'TutorCalendar',
    component: () => import('@/views/pages/user/Tutor/TutorCalendar.vue'),
    meta: {
      ref: ['tutor', 'tutor-calendar'],
      layout: 'content',
      title: 'menu.tutorCalendar',
      requireAuth: true,
      cannotAccess: ['TutorCalendar'],
    },
  },
  {
    path: '/tutor-leave-apply',
    name: 'TutorLeave',
    component: () => import('@/views/pages/user/Tutor/TutorLeave.vue'),
    meta: {
      ref: ['tutor', 'tutor-leave'],
      layout: 'content',
      title: 'menu.tutorLeave',
      requireAuth: true,
      cannotAccess: ['TutorLeave'],
    },
  },
  {
    path: '/leave-apply',
    name: 'TutorUserLeave',
    component: () => import('@/views/pages/user/Tutor/TutorLeave.vue'),
    meta: {
      ref: ['tutor', 'tutor-leave'],
      layout: 'content',
      title: 'menu.tutorLeave',
      requireAuth: true,
      cannotAccess: ['TutorUserLeave'],
    },
  },
  {
    path: '/promotion',
    name: 'CouponList',
    component: () => import('@/views/pages/user/Coupon/CouponList.vue'),
    meta: {
      ref: ['coupon'],
      layout: 'content',
      title: 'menu.coupon',
      requireAuth: true,
      cannotAccess: ['CouponList'],
    },
  },
  {
    path: '/promotion/details/:id',
    name: 'CouponDetails',
    component: () => import('@/views/pages/user/Coupon/CouponDetails.vue'),
    meta: {
      ref: ['coupon'],
      layout: 'content',
      title: 'couponDetails',
      requireAuth: true,
      cannotAccess: ['CouponDetails'],
    },
  },
  {
    path: '/promotion/create',
    name: 'CreateCoupon',
    component: () => import('@/views/pages/user/Coupon/CouponDetails.vue'),
    meta: {
      ref: ['coupon'],
      layout: 'content',
      title: 'createCoupon',
      requireAuth: true,
      cannotAccess: ['CreateCoupon'],
    },
  },
  {
    path: '/setting/basic',
    name: 'BasicSetting',
    component: () => import('@/views/pages/user/Setting/BasicSetting.vue'),
    meta: {
      ref: ['setting', 'setting-basic'],
      layout: 'content',
      title: 'menu.basicSetting',
      requireAuth: true,
      cannotAccess: ['Setting'],
    },
  },
  {
    path: '/setting/payment',
    name: 'PaymentSetting',
    component: () => import('@/views/pages/user/Setting/PaymentSetting.vue'),
    meta: {
      ref: ['setting', 'setting-payment'],
      layout: 'content',
      title: 'menu.paymentSetting',
      requireAuth: true,
      cannotAccess: ['Setting'],
    },
  },
  {
    path: '/setting/points',
    name: 'PointsSetting',
    component: () => import('@/views/pages/user/Setting/PointsSetting.vue'),
    meta: {
      ref: ['setting', 'setting-points'],
      layout: 'content',
      title: 'menu.pointsSetting',
      requireAuth: true,
      cannotAccess: ['Setting'],
    },
  },
  {
    path: '/setting/holiday',
    name: 'HolidaySetting',
    component: () => import('@/views/pages/user/Setting/HolidaySetting.vue'),
    meta: {
      ref: ['setting', 'setting-holiday'],
      layout: 'content',
      title: 'menu.holidaySetting',
      requireAuth: true,
      cannotAccess: ['Setting'],
    },
  },
  {
    path: '/setting/switch',
    name: 'SwitchSetting',
    component: () => import('@/views/pages/user/Setting/SwitchSetting.vue'),
    meta: {
      ref: ['setting', 'setting-requirement'],
      layout: 'content',
      title: 'menu.switchSetting',
      requireAuth: true,
      cannotAccess: ['Setting'],
    },
  },
  {
    path: '/setting/whatsapp',
    name: 'WhatsAppSetting',
    component: () => import('@/views/pages/user/Setting/WhatsAppSetting.vue'),
    meta: {
      ref: ['setting', 'setting-basic'],
      layout: 'content',
      title: 'menu.whatsAppSetting',
      requireAuth: true,
      cannotAccess: ['Setting'],
    },
  },
  {
    path: '/package',
    name: 'PackageList',
    component: () => import('@/views/pages/user/Package/PackageList.vue'),
    meta: {
      ref: ['package'],
      layout: 'content',
      title: 'menu.package',
      requireAuth: true,
      cannotAccess: ['PackageList'],
    },
  },
  {
    path: '/package/details/:id',
    name: 'PackageDetails',
    component: () => import('@/views/pages/user/Package/PackageDetails.vue'),
    meta: {
      ref: ['package'],
      layout: 'content',
      title: 'packageDetails',
      requireAuth: true,
      cannotAccess: ['PackageDetails'],
    },
  },
  {
    path: '/package/create',
    name: 'CreatePackage',
    component: () => import('@/views/pages/user/Package/PackageDetails.vue'),
    meta: {
      ref: ['package'],
      layout: 'content',
      title: 'createPackage',
      requireAuth: true,
      cannotAccess: ['CreatePackage'],
    },
  },
  {
    path: '/report',
    name: 'Report',
    component: () => import('@/views/pages/user/Report.vue'),
    meta: {
      ref: ['report'],
      layout: 'content',
      title: 'menu.report',
      requireAuth: true,
      cannotAccess: ['Report'],
    },
  },
  {
    path: '/requirement',
    name: 'SwitchRequirement',
    component: () => import('@/views/pages/user/SwitchRequirement.vue'),
    meta: {
      ref: ['requirement'],
      layout: 'content',
      title: 'menu.requirement',
      requireAuth: true,
      cannotAccess: ['SwitchRequirement'],
    },
  },
  {
    path: '/notify',
    name: 'NotifyList',
    component: () => import('@/views/pages/user/Notification/NotifyList.vue'),
    meta: {
      ref: ['notify'],
      layout: 'content',
      title: 'menu.notification',
      requireAuth: true,
      cannotAccess: ['NotifyList'],
    },
  },
  {
    path: '/notify/details/:id',
    name: 'NotifyDetails',
    component: () => import('@/views/pages/user/Notification/NotifyDetails.vue'),
    meta: {
      ref: ['notify'],
      layout: 'content',
      title: 'notifyDetails',
      requireAuth: true,
      cannotAccess: ['NotifyDetails'],
    },
  },
  {
    path: '/notify/create',
    name: 'CreateNotify',
    component: () => import('@/views/pages/user/Notification/NotifyDetails.vue'),
    meta: {
      ref: ['notify'],
      layout: 'content',
      title: 'createNotify',
      requireAuth: true,
      cannotAccess: ['CreateNotify'],
    },
  },
  {
    path: '/blog-category',
    name: 'BlogCategoryList',
    component: () => import('@/views/pages/user/Blog/BlogCategoryList.vue'),
    meta: {
      ref: ['other', 'blog', 'blog-category'],
      layout: 'content',
      title: 'menu.blogCategory',
      requireAuth: true,
      cannotAccess: ['BlogCategoryList'],
    },
  },
  {
    path: '/blog-category/details/:id',
    name: 'BlogCategoryDetails',
    component: () => import('@/views/pages/user/Blog/BlogCategoryDetails.vue'),
    meta: {
      ref: ['other', 'blog', 'blog-category'],
      layout: 'content',
      title: 'blogCategoryDetails',
      requireAuth: true,
      cannotAccess: ['BlogCategoryDetails'],
    },
  },
  {
    path: '/blog-category/create',
    name: 'CreateBlogCategory',
    component: () => import('@/views/pages/user/Blog/BlogCategoryDetails.vue'),
    meta: {
      ref: ['other', 'blog', 'blog-category'],
      layout: 'content',
      title: 'createBlogCategory',
      requireAuth: true,
      cannotAccess: ['CreateBlogCategory'],
    },
  },
  {
    path: '/blog',
    name: 'BlogList',
    component: () => import('@/views/pages/user/Blog/BlogList.vue'),
    meta: {
      ref: ['other', 'blog', 'blog-list'],
      layout: 'content',
      title: 'menu.blog',
      requireAuth: true,
      cannotAccess: ['BlogList'],
    },
  },
  {
    path: '/blog/details/:id',
    name: 'BlogDetails',
    component: () => import('@/views/pages/user/Blog/BlogDetails.vue'),
    meta: {
      ref: ['other', 'blog', 'blog-list'],
      layout: 'content',
      title: 'blogDetails',
      requireAuth: true,
      cannotAccess: ['BlogDetails'],
    },
  },
  {
    path: '/blog/create',
    name: 'CreateBlog',
    component: () => import('@/views/pages/user/Blog/BlogDetails.vue'),
    meta: {
      ref: ['other', 'blog', 'blog-list'],
      layout: 'content',
      title: 'createBlog',
      requireAuth: true,
      cannotAccess: ['CreateBlog'],
    },
  },
  {
    path: '/video-category',
    name: 'VideoCategoryList',
    component: () => import('@/views/pages/user/Video/VideoCategoryList.vue'),
    meta: {
      ref: ['other', 'video', 'video-category'],
      layout: 'content',
      title: 'menu.videoCategory',
      requireAuth: true,
      cannotAccess: ['VideoCategoryList'],
    },
  },
  {
    path: '/video-category/details/:id',
    name: 'VideoCategoryDetails',
    component: () => import('@/views/pages/user/Video/VideoCategoryDetails.vue'),
    meta: {
      ref: ['other', 'video', 'video-category'],
      layout: 'content',
      title: 'videoCategoryDetails',
      requireAuth: true,
      cannotAccess: ['VideoCategoryDetails'],
    },
  },
  {
    path: '/video-category/create',
    name: 'CreateVideoCategory',
    component: () => import('@/views/pages/user/Video/VideoCategoryDetails.vue'),
    meta: {
      ref: ['other', 'video', 'video-category'],
      layout: 'content',
      title: 'createVideoCategory',
      requireAuth: true,
      cannotAccess: ['CreateVideoCategory'],
    },
  },
  {
    path: '/video',
    name: 'VideoList',
    component: () => import('@/views/pages/user/Video/VideoList.vue'),
    meta: {
      ref: ['other', 'video', 'video-list'],
      layout: 'content',
      title: 'menu.allVideos',
      requireAuth: true,
      cannotAccess: ['VideoList'],
    },
  },
  {
    path: '/video/details/:id',
    name: 'VideoDetails',
    component: () => import('@/views/pages/user/Video/VideoDetails.vue'),
    meta: {
      ref: ['other', 'video', 'video-list'],
      layout: 'content',
      title: 'videoDetails',
      requireAuth: true,
      cannotAccess: ['VideoDetails'],
    },
  },
  {
    path: '/video/create',
    name: 'CreateVideo',
    component: () => import('@/views/pages/user/Video/VideoDetails.vue'),
    meta: {
      ref: ['other', 'video', 'video-list'],
      layout: 'content',
      title: 'createVideo',
      requireAuth: true,
      cannotAccess: ['CreateVideo'],
    },
  },
  {
    path: '/monthly-package',
    name: 'MonthPassList',
    component: () => import('@/views/pages/user/MonthPass/MonthPassList.vue'),
    meta: {
      ref: ['month-pass'],
      layout: 'content',
      title: 'menu.monthPass',
      requireAuth: true,
      cannotAccess: ['MonthPassList'],
    },
  },
  {
    path: '/monthly-package/details/:id',
    name: 'MonthPassDetails',
    component: () => import('@/views/pages/user/MonthPass/MonthPassDetails.vue'),
    meta: {
      ref: ['month-pass'],
      layout: 'content',
      title: 'monthPassDetails',
      requireAuth: true,
      cannotAccess: ['MonthPassDetails'],
    },
  },
  {
    path: '/monthly-package/create',
    name: 'CreateMonthPass',
    component: () => import('@/views/pages/user/MonthPass/MonthPassDetails.vue'),
    meta: {
      ref: ['month-pass'],
      layout: 'content',
      title: 'createMonthPass',
      requireAuth: true,
      cannotAccess: ['CreateMonthPass'],
    },
  },
  {
    path: '/about-us',
    name: 'AboutUs',
    component: () => import('@/views/pages/user/CustomPage.vue'),
    meta: {
      ref: ['other', 'about-us'],
      layout: 'content',
      title: 'menu.aboutUs',
      requireAuth: true,
      cannotAccess: ['Setting'],
    },
  },
  {
    path: '/website/home',
    name: 'WebsiteHomeSetting',
    component: () => import('@/views/pages/user/Website/HomeSetting.vue'),
    meta: {
      ref: ['other', 'website-setting', 'website-setting-home'],
      layout: 'content',
      title: 'menu.homeDesign',
      requireAuth: true,
      cannotAccess: ['Setting'],
    },
  },
  {
    path: '/website/payment',
    name: 'WebsitePaymentSetting',
    component: () => import('@/views/pages/user/Setting/PaymentSetting.vue'),
    meta: {
      ref: ['other', 'website-setting', 'website-setting-payment'],
      layout: 'content',
      title: 'menu.paymentSetting',
      requireAuth: true,
      cannotAccess: ['Setting'],
    },
  },
  {
    path: '/group',
    name: 'GradeSetting',
    component: () => import('@/views/pages/user/GradeSetting.vue'),
    meta: {
      ref: ['grade'],
      layout: 'content',
      title: 'menu.grade',
      requireAuth: true,
      cannotAccess: ['GradeSetting'],
    },
  },
  {
    path: '/useful-links',
    name: 'UsefulLinks',
    component: () => import('@/views/pages/user/CustomPage.vue'),
    meta: {
      ref: ['other', 'useful-links'],
      layout: 'content',
      title: 'menu.usefulLinks',
      requireAuth: true,
      cannotAccess: ['Setting'],
    },
  },
  {
    path: '/festival-promotions',
    name: 'FestivalPromotions',
    component: () => import('@/views/pages/user/CustomPage.vue'),
    meta: {
      ref: ['other', 'festival-promotions'],
      layout: 'content',
      title: 'menu.festivalPromotions',
      requireAuth: true,
      cannotAccess: ['Setting'],
    },
  },
  {
    path: '/faq',
    name: 'Faq',
    component: () => import('@/views/pages/user/CustomPage.vue'),
    meta: {
      ref: ['other', 'faq'],
      layout: 'content',
      title: 'menu.faq',
      requireAuth: true,
      cannotAccess: ['Setting'],
    },
  },
  {
    path: '/collaborations',
    name: 'Collaborations',
    component: () => import('@/views/pages/user/CustomPage.vue'),
    meta: {
      ref: ['other', 'collaborations'],
      layout: 'content',
      title: 'menu.collaborations',
      requireAuth: true,
      cannotAccess: ['Setting'],
    },
  },
  {
    path: '/enquiry',
    name: 'Enquiry',
    component: () => import('@/views/pages/user/Enquiry.vue'),
    meta: {
      ref: ['enquiry'],
      layout: 'content',
      title: 'menu.enquiry',
      requireAuth: true,
      cannotAccess: ['Enquiry'],
    },
  },
  {
    path: '*',
    name: 'Error',
    component: () => import('@/views/Error.vue'),
    meta: {
      layout: 'blank',
      title: 'Error',
    },
  },
];